import { root, auth, notFound } from 'routing/common';

export default [...root, ...auth, ...notFound];
